"use strict";
/**
 * **The envelope of a class-C entity.** GH527 · SP8 §3ter.
 *
 * A class-C entity is ours and carries QVET's mirror **inside it**
 * (`.claude/rules/modelos-y-qvet.md`). There are four today: articles, warehouses, sections and
 * suppliers.
 *
 * ## Why the response separates the two halves instead of flattening them
 *
 * > *«Si hay campos en ambos lados no puede vivir igual.»* — Javier, 2026-09-12
 *
 * Flattening was the right call while our half was **one flag**: the response kept its shape and
 * no screen noticed. It stops being right the moment there are fields on both sides, because
 * then the response **does not say who owns each one** — and that is not cosmetic:
 *
 * | | who owns it | what happens when it is edited |
 * |---|---|---|
 * | `qvetSync` | **QVET** | it is **proposed**: it lands in `pendingChanges` and waits for the write engine |
 * | `hvpData` | **us** | it is written and that is that; the sync never touches it |
 *
 * With a flat response, `name` and `countsInStockSnapshot` look alike, and **the screen cannot
 * tell which of the two will survive tonight's sync**.
 *
 * ## And one shape for both list and detail
 *
 * Warehouses, sections and suppliers have **few fields** — 2, 4 and 17 — so splitting the
 * response in two only produces two places to forget adding a field. The **article** is the
 * exception, and only because of its size: 191 fields and five grids.
 *
 * ## ⚠️ What does NOT get an envelope
 *
 * A **catalogue meant to paint a dropdown** — `QvetFormCatalogs.warehouses`, say — stays flat.
 * It is a derived projection, not the entity: whoever renders a `<select>` needs an id and a
 * name, not who owns each field. Confusing the two is what put the warehouse's own half inside
 * a catalogue entry in the first place.
 */
Object.defineProperty(exports, "__esModule", { value: true });
